import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export const Box = styled.div`
  padding: 10px 60px;
  background: #fff;
  bottom: 0;
  width: 100%;

  @media (max-width: 1000px) {
    padding: 10px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-around;

  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: unset;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  color: #373236;
  font-size: 16px;
`;

const Footer = () => {
  const { t } = useTranslation("footer");

  return (
    <Box>
      <Row>
        <Column>{t("copy_rights")}</Column>
        <Column>{t("designed_by")}</Column>
      </Row>
    </Box>
  );
};
export default Footer;
